<div class="row">
  <div class="col-md-5" style="padding-left: 32px;">

    <table border="2" bordercolor="white" class="table table-condensed table-hover patient-details">
      <tbody>
        <tr tooltip="Patient ID: {{ selectedPatient.remotePersonId }}">
          <th class="col-md-2" style="width: 150px">First name</th>
          <td>{{selectedPatient.firstName}}</td>
        </tr>
        <tr>
          <th style="width: 150px">Middle name</th>
          <td>{{selectedPatient.middleName}}</td>
        </tr>
        <tr>
          <th style="width: 150px">Last name</th>
          <td>{{selectedPatient.lastName}}</td>
        </tr>
        <tr>
          <th style="width: 150px">Birthday</th>
          <td>{{selectedPatient.birthday | date: 'longDate' }}</td>
        </tr>
        <tr>
          <th style="width: 150px">Status</th>
          <td>
            <span *ngIf="selectedPatient.personState === 'active' else noactive"> {{selectedPatient.personState }}</span>
            <ng-template #noactive>
              <b style="color: red">{{selectedPatient.personState}}</b>
            </ng-template>
          </td>
        </tr>

      </tbody>
    </table>

  </div>
  <div class="col-md-5">

    <table border="2" bordercolor="white" style="margin-bottom: 0px"
    class="table table-condensed table-hover patient-details">
      <tbody>
        <tr *ngFor="let destinator of selectedPatient.destinators">
          <th style="width: 120px" *ngIf="destinator.address !== undefined && destinator.address.length > 0">{{'_destinatorType_' + destinator.type + '_' | translate}}</th>
          <th class="subscribeTag" style="width: 20px" *ngIf="destinator.address !== undefined && destinator.address.length > 0"
            (click)="openSubscriptionsDialog(destinator)">
            <img tooltip="Click to edit subscription to various types of messages"
              *ngIf="!destinator.blocked" src="/img/subscribe.png"/>
            <img tooltip="Unsubscribed for at least one type of message. Click to edit subscriptions"
                 *ngIf="destinator.blocked" src="/img/unsubscribe.png"/>
          </th>
          <th style="width: 20px" *ngIf="hasTwoWay && selectedPatient.personState === 'active' && destinator.address !== undefined && destinator.address.length > 0">
            <a
                href="#"
                [routerLink]="['/two-way']" [queryParams]="{destinatorid: destinator.destinatorId, personid: selectedPatient.personId}"
                *ngIf="destinator.address.length !== 0 && destinator.type === 'phonecell'">
              <img tooltip="Click to select this patient and phone number for Two Way texting"
              *ngIf="!destinator.blocked" src="/img/two-way.png" style="width:20px"/>
            </a>
          </th>
            <td  *ngIf="destinator.address !== undefined && destinator.address.length > 0" >{{destinator.address}}</td>
        </tr>
      </tbody>
    </table>

  </div>
  <div *ngIf="selectedPatient.remotePersonId.startsWith('t.')"
    class="col-md-12">
      NOTE: This patient was created as a "temporary patient" for an appointment created without a chart.
  </div>

</div>
